import { openErrorModal } from '../../actions'
import { getCroppedImg } from '../../utils/image'
import { ERROR_ADDING_IMAGE } from '../../constants'

export const onCropChange = (crop, component) => {
  component.setState({ crop });
};

export const onZoomChange = (zoom, component) => {
  component.setState({ zoom });
};
export const onChangePicture = (picture, component) => {
  component.setState({ picture, cropSize: null, zoom: 1, crop: { x: 0, y: 0 }, initialCroppedAreaPixels: null });
};


const hasCroppedAreaChanged = (a, b, tolerance = 1) => {
  if (!a || !b) {
    return false
  }
  return (
    Math.abs(a.x - b.x) > tolerance ||
    Math.abs(a.y - b.y) > tolerance ||
    Math.abs(a.width - b.width) > tolerance ||
    Math.abs(a.height - b.height) > tolerance
  );
};

export const onCropComplete = async (_, croppedAreaPixels, component) => {
  const { setCroppedImage, fileType, saveConfigOnly, setImageConfig } = component.props;
  const { picture, zoom, initialCroppedAreaPixels, initialZoom } = component.state;

  try {
    if (!initialCroppedAreaPixels) {
      component.setState({ initialCroppedAreaPixels: croppedAreaPixels });
    }
    if (saveConfigOnly) {
      const initial = initialCroppedAreaPixels || croppedAreaPixels;
      const cropChanged = hasCroppedAreaChanged(croppedAreaPixels, initial, 1);
      const zoomChanged = initialZoom !== zoom
      const hasUserEdited = cropChanged || zoomChanged;
      setImageConfig({ imageUrl: picture[0].imageUrl, croppedAreaPixels, fileType, hasUserEdited })
    } else {
      const croppedImageUrl = await getCroppedImg(picture[0].imageUrl, croppedAreaPixels, fileType);
      setCroppedImage(croppedImageUrl);
    }
  } catch (e) {
    openErrorModal(ERROR_ADDING_IMAGE);
  }
};
